import axios from './axios.service';

export default class Banners {
  /**
   *
   * @param {String} status ACTIVE | INACTIVE | ALL
   */
  static list(status = 'ALL') {
    return axios.get(
      `/api/v2/cmt-backend/offers/banners/list?active=${status}`,
    );
  }

  /**
   *
   * @param {Number} id
   */
  static get(id) {
    return axios.get(`/api/v2/cmt-backend/offers/banners/${id}`);
  }

  /**
   *
   * @param {Number} id
   */
  static delete(id) {
    return axios.delete(`/api/v2/cmt-backend/offers/banners/${id}`);
  }

  /**
   *
   * @param {Object} bannerData
   */
  static create(bannerData) {
    return axios.post(`/api/v2/cmt-backend/offers/banners`, bannerData);
  }

  /**
   * @param {Number} id
   * @param {Object} bannerData
   */
  static update(id, bannerData) {
    return axios.put(`/api/v2/cmt-backend/offers/banners/${id}`, bannerData);
  }
}
